/**
 * Identificador estável deste navegador, gerado na primeira vez. Vai em todo pedido à API (cabeçalho
 * X-Walleon-Dispositivo): o servidor mantém uma sessão de login por aparelho ou navegador, então entrar aqui
 * não derruba o login do celular.
 */
const CHAVE = 'walleon.deviceId'

let emMemoria: string | null = null

export function idDoDispositivo(): string {
  if (emMemoria) return emMemoria
  try {
    const salvo = window.localStorage.getItem(CHAVE)
    if (salvo) return (emMemoria = salvo)
    const novo = crypto.randomUUID()
    window.localStorage.setItem(CHAVE, novo)
    return (emMemoria = novo)
  } catch {
    // Armazenamento bloqueado (janela anônima restrita): vale só para esta aba.
    return (emMemoria = crypto.randomUUID())
  }
}
